// inputs.js
import { validateRequired,validateLength, validateNonZeroInteger,validateNotNull }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Codigo",
    name: "codigo_rubro",
    type: "text",
    placeholder: "Ingrese el codigo",
      validation: (value, form) => {
          // Validación requerida
          const requiredError = validateNotNull(value);
          if (requiredError) {
            return requiredError;
          }
              // Si no hay errores
          return null;
        }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "descripcion_rubro",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Ramo",
    name: "ramo_Id",
    type: "select", // Cambiado a "select"
    options: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }
      // Si no hay errores
      return null;
    }
  },
   
  {
    id: 4,
    label: "Mostrar en Web",
    name: "rubro_show_web",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
   {
    id: 5,
    label: "Mostrar en App",
    name: "rubro_show_app",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  // Agrega más campos aquí
];

export default Inputs;
